import { getUsers, isUsersFetching } from "reducers";
import PropTypes from "prop-types";
import {
  USER_FETCH_ACTION_CREATORS,
  ADMINISTRATOR,
  exportUserTable
} from "actions/users";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import DataColumnFilterTable from "components/ui/data-column-filter-table";
import { InlineWaiting, PageHeader } from "components/ui";
import capitalize from "lodash/capitalize";
import { formatPhone } from "utils/misc";
import { FaGlobe } from "react-icons/lib/fa";

const [fetchUsers, invalidateUsers] = USER_FETCH_ACTION_CREATORS[ADMINISTRATOR];
class MultiFilterAdministratorTable extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.handleRefresh();
  }

  handleRefresh = () => {
    const { dispatch } = this.props;
    dispatch(invalidateUsers());
    dispatch(fetchUsers());
  };

  handleExport = filteredRows => {
    this.props.dispatch(exportUserTable("administrators", filteredRows));
  };

  render() {
    const { users, isFetching } = this.props;
    const nameSort = ({ name }) => capitalize(name);

    return (
      <div>
        <PageHeader title="Administrators" />
        <DataColumnFilterTable
          columns={[
            {
              title: "Sort by name",
              header: "Name",
              field: user => user.name,
              format: user => (
                <Link to={`/users/${user.id}`}>
                  {user.name} {user.contracted_employee ? <FaGlobe /> : ""}
                </Link>
              ),

              filterTest: "name"
            },
            {
              title: "Sort by Email",
              header: "Email",
              field: user => user.email
            },
            {
              title: "Sort By Phone Number",
              header: "Phone Number",
              field: user => formatPhone(user.phone_number)
            },
            {
              title: "Sort by Active",
              header: "Active",
              field: user => user.active.toString(),
              boolean: true
            }
          ]}
          rows={users}
          onRefresh={this.handleRefresh}
          onExport={this.handleExport}
          initialSort={{ iteratee: nameSort }}
          initialFilters={[
            {
              input: "",
              columnIndex: 3,
              testOpKey: "REG_EXP",
              selectActiveBoolean: "true"
            }
          ]}
        />
        {isFetching && <InlineWaiting reason="Fetching Administrators..." />}
      </div>
    );
  }
}

export default connect(state => ({
  users: getUsers(state, ADMINISTRATOR),
  isFetching: isUsersFetching(state, ADMINISTRATOR)
}))(MultiFilterAdministratorTable);

MultiFilterAdministratorTable.propTypes = {
  users: PropTypes.arrayOf(PropTypes.object).isRequired,
  isFetching: PropTypes.bool,
  dispatch: PropTypes.func.isRequired
};
